import { render } from "./TemplateUpdate.vue?vue&type=template&id=6b3683ea&scoped=true"
import script from "./TemplateUpdate.vue?vue&type=script&lang=js"
export * from "./TemplateUpdate.vue?vue&type=script&lang=js"

import "./TemplateUpdate.vue?vue&type=style&index=0&id=6b3683ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3683ea"]])

export default __exports__